import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { formatDateToShort, formatTimeToAmPm, toDefaultDateTimeFormat } from "@/helpers/dates";
import { BusinessReportsOutcomeListRowStatus } from "@/modules/snapshots/outcomeListRowStatus";
import { CircleLoader } from "@/components/ui/circleLoader";
import colors from "tailwindcss/colors";
import { SnapshotCollectionsOutcomesRowVerified } from "./rowVerified";
import { SnapshotCollectionsOutcomesRowActions } from "./rowActions";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const SnapshotCollectionsOutcomesRow: React.FC<Props> = ({ businessReportOutcome }) => {
  const normalizedProgressbar = parseInt(String((businessReportOutcome.snapshot_progress || 0) * 100), 10);
  return (
    <tr>
      <td className="py-4 pl-4 pr-3 text-sm sm:pl-6" title={businessReportOutcome.name}>
        <div style={{ maxWidth: "400px" }} className="truncate font-medium text-gray-900">
          {businessReportOutcome.name}
        </div>
        <div style={{ maxWidth: "400px" }} className={"mt-2 text-sm text-gray-500"}>
          {businessReportOutcome.answer}
        </div>
      </td>
      <td
        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
        title={toDefaultDateTimeFormat(businessReportOutcome.created_at)}
      >
        <span>{formatDateToShort(businessReportOutcome.created_at)}</span>
        <span>·</span>
        <span>{formatTimeToAmPm(businessReportOutcome.created_at)}</span>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <div className="justify-content-start flex" style={{ width: 200 }}>
          {businessReportOutcome.status === "IN_PROGRESS" && (
            <div className="mr-1">
              <div className="flex items-center">
                <CircleLoader fill={colors.gray[500]} />
                <div className="text-xs">{normalizedProgressbar}%</div>
              </div>
            </div>
          )}
          <BusinessReportsOutcomeListRowStatus status={businessReportOutcome.status} />
        </div>
      </td>
      <td className="px-3 py-4 text-sm">
        <SnapshotCollectionsOutcomesRowVerified businessReportOutcome={businessReportOutcome} />
      </td>
      <td className="whitespace-nowrap pl-3">
        <SnapshotCollectionsOutcomesRowActions businessReportOutcome={businessReportOutcome} />
      </td>
    </tr>
  );
};
